__turbopack_context__.v({
  "actionButton": "OrderConfigurationModalHeader-module-scss-module__x9nFeW__actionButton",
  "eyebrow": "OrderConfigurationModalHeader-module-scss-module__x9nFeW__eyebrow",
  "header": "OrderConfigurationModalHeader-module-scss-module__x9nFeW__header",
  "headerWithBack": "OrderConfigurationModalHeader-module-scss-module__x9nFeW__headerWithBack",
  "headerWithClose": "OrderConfigurationModalHeader-module-scss-module__x9nFeW__headerWithClose",
  "titleGroup": "OrderConfigurationModalHeader-module-scss-module__x9nFeW__titleGroup",
});
